exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DynamicAmount_formItem_2ogDo{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;width:100%;position:relative}.DynamicAmount_formItem_2ogDo.DynamicAmount__oneLine_PWE6s{width:-webkit-calc(50% - 10px);width:calc(50% - 10px)}", ""]);

// exports
exports.locals = {
	"formItem": "DynamicAmount_formItem_2ogDo",
	"_oneLine": "DynamicAmount__oneLine_PWE6s"
};